import styled, { css } from 'styled-components';
import { colors, MediaQuery, styleHelpers } from '../../theme/style-helpers';
import CheckmarkIconOrange from '../../assets/icons/checkmark_icon_orange.svg';

export const Container = styled.main`
    width: 100%;
    padding: 36px 0 48px 0;
    ${MediaQuery.small(css`
        padding: 64px 0px 48px;
    `)}
    ${MediaQuery.xLarge(css`
        display: flex;
        align-items: center;
        flex-direction: column;
        padding-bottom: 80px;
    `)}
`;

export const Header = styled.section`
    padding: 0 0px 32px;
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 16px;

    ${MediaQuery.small(css`
        padding: 0 0 48px;
    `)}

    ${MediaQuery.xLarge(css`
        width: 872px;
    `)}
`;

export const Title = styled.h1`
    font-size: 28px;
    line-height: 130%;
    font-weight: 500;
    color: ${colors.BLACK};
    margin: 0;

    ${MediaQuery.small(css`
        font-size: 36px;
    `)}
`;

export const Description = styled.p`
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.01em;
    color: ${colors.BLACK};
    margin: 0;
    font-weight: 400;
`;

export const Form = styled.form`
    padding: 40px 20px;
    margin: 0px -20px;
    background-color: #F9F9F9;
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 40px;

    ${MediaQuery.small(css`
        width: 100%;
        padding: 56px 40px;
        border-radius: 4px;
        margin: 0px;
    `)}

    ${MediaQuery.xLarge(css`
        display: flex;
        flex-direction: column;
        align-items: center;
    `)}
`;

export const FormGroup = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 16px;

    ${MediaQuery.small(css`
        grid-template-columns: repeat(3, 1fr);
        column-gap: 24px;
    `)}

    ${MediaQuery.xLarge(css`
        width: 872px;
        grid-template-columns: repeat(4, 1fr);
    `)}
`;

export const FormGroupTitle = styled.h2`
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    margin: 0;
    grid-column: 1 / -1;

    ${MediaQuery.xLarge(css`
        grid-column: 1;
    `)}
`;

export const SubmitButtonContainer = styled.div`
    display: grid;

    ${MediaQuery.small(css`
        grid-template-columns: repeat(3, 1fr);
        column-gap: 24px;

        button {
            grid-column: 3;
        }
    `)}

    ${MediaQuery.xLarge(css`
        width: 872px;
        grid-template-columns: repeat(4, 1fr);

        button {
            grid-column: 4;
        }
    `)}
`;

export const CheckboxesContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 20px;

    ${MediaQuery.small(css`
        column-gap: 32px;
        grid-column: 1 / -1;
        display: flex;
        flex-wrap: wrap;
    `)}
    ${MediaQuery.xLarge(css`
        grid-column: 2 / -1;
        display: flex;
        flex-wrap: wrap;
    `)}
`;

export const Checkbox = styled.div`
    user-select: none;
    display: grid;
    grid-template-columns: max-content max-content;
    column-gap: 12px;
    align-items: center;
`;

export const CheckboxInput = styled.input`
    cursor: pointer;
    appearance: none;
    width: 20px;
    height: 20px;
    border: 1px solid #63666A;
    box-sizing: border-box;
    border-radius: 2px;

    &:checked {
        background-position: center center;
        background-repeat: no-repeat;
        background-image: url(${CheckmarkIconOrange});
        border-color: ${colors.BRAND_ORANGE};
        border-width: 2px;
    }
`;

export const CheckboxLabel = styled.label`
    cursor: pointer;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: ${colors.BLACK};
    margin: 0;
`;

export const ResultsSection = styled.section`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    padding: 32px 0 0;
    row-gap: 24px;

    ${MediaQuery.small(css`
        padding: 48px 0 0;
    `)}

    ${MediaQuery.xLarge(css`
        row-gap: 40px;
    `)}
`;

export const ResultsTitle = styled.h2`
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.01em;
    color: ${colors.BLACK};
    margin: 0;
`;

export const CardsContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 24px;

    ${MediaQuery.small(css`
        grid-template-columns: repeat(2, 1fr);
        column-gap: 24px;
    `)}

    ${MediaQuery.xLarge(css`
        display: none;
    `)}
`;

export const Card = styled.div`
    padding: 24px 12px;
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 24px;
    border: 1px solid #F9F9F9;
    box-sizing: border-box;
    background-color: ${colors.WHITE};
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 4px;

    ${MediaQuery.xLarge(css`
        width: 352px;
    `)}
`;

export const CardHeader = styled.h3`
    font-weight: 500;
    font-size: 24px;
    line-height: 130%;
    text-align: center;
    color: ${colors.BLACK};
    margin: 0;
`;

export const CardBodyTable = styled.div`
    display: grid;
    row-gap: 8px;
    grid-auto-flow: row;
`;

export const TableHeadRow = styled.div`
    display: grid;
    grid-template-columns: 108px auto 98px;
`;

export const TableHeadCell = styled.div`
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    color: ${colors.BLACK};

    &:nth-child(2){
        text-align: center;
    }
`;

export const TableBodyRow = styled.div`
    background: #F9F9F9;
    border-radius: 4px;
    padding: 15px 12px;
    display: grid;
    grid-template-columns: 94px auto max-content;
    align-items: center;
`;

export const TableBodyCell = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
    color: ${colors.BLACK};

    &:first-of-type {
        font-weight: 500;
    }

    &:nth-of-type(2) {
        text-align: center;
    }

    &:last-of-type {
        text-align: right;
    }
`;

export const CardFooter = styled.p`
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    text-align: center;
    color: ${colors.BLACK};
    margin: 0;
    justify-self: center;
`;

export const DesktopResults = styled.table`
    display: none;

    ${MediaQuery.xLarge(css`
        display: table;
    `)}

    border-collapse: collapse;

    th {
        border-right: 1px solid #D9D9D6;

        &:last-of-type {
            border-right: none;
        }

       > div {
            display: grid;
            grid-template-rows: 31px max-content;
            row-gap: 12px;
            padding-left: 50px;
            padding-right: 50px;
            padding-bottom: 12px;
        }

        &:first-of-type {
            > div {
                padding-left: 33px;
            }
        }
    }

`;

export const DesktopResultZip = styled.h3`
    font-weight: 500;
    font-size: 24px;
    line-height: 130%;
    color: ${colors.BLACK};
    margin: 0;
`;

export const DesktopResultHeader = styled.div`
    display: flex;
    grid-row: 2;

    h4 {
        width: 120px;
        font-weight: 600;
        font-size: 16px;
        line-height: 150%;
        letter-spacing: 0.01em;
        color: ${colors.BLACK};
        margin: 0;
    }
`;

export const DesktopResultCell = styled.td`
    border-right: 1px solid #D9D9D6;
    padding: 0;

    &:last-of-type {
        border-right: none;
    }

    &:first-of-type {
        > div {
            border-radius: 4px 0 0 4px;
        }
    }

    &:last-of-type {
        > div {
            border-radius: 0 4px 4px 0;
        }
    }
`;

export const DesktopResultSideHeader = styled.div`
    width: 238px;
    font-weight: 600;
    font-size: 18px;
    line-height: 150%;
    color: ${colors.BLACK};
    background-color: #F9F9F9;
    padding-right: 50px;
    padding-left: 32px;
    margin-bottom: 12px;
    height: 72px;
    display: flex;
    align-items: center;
`;

export const DesktopResultData = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 72px;
    background-color: #F9F9F9;
    padding-right: 50px;
    padding-left: 50px;
    margin-bottom: 12px;
`;

export const DesktopResultValue = styled.p`
    margin: 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.01em;
    color: ${colors.BLACK};
    width: 120px;
`;

export const DesktopResultsFooter = styled.p`
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    text-align: center;
    color: ${colors.BLACK};
    margin: 0;
    text-align: center;
    display: none;
    padding-bottom: 32px;

    ${MediaQuery.xLarge(css`
        display: block;
    `)}
`;

export const PageTitle = styled.div`
    font-weight: 300;
    font-size: 4.8rem;
    margin-bottom: 32px;

    &.justified {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
`;

export const ContentBoxLightGrey = styled.div`
    background-color: ${colors.LIGHT_GREY};
    padding: 32px;
    box-shadow: 0 32px 6px -30px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    width: 100%;
    margin: 40px 0;
    position: relative;
    flex-wrap: wrap;

    .title-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 24px;
        flex-wrap: wrap;

        p {
            margin: 0;
        }

        > &:nth-child(even) {
            background-color: ${colors.WHITE};
        }
    }

    h2, h3 {
        color: ${colors.DARK_GREY};
    }
`;

export const MeasurementTab = styled.div`
    font-weight: 500;
    font-size: 1.6rem;
    margin-top: 10px;
    margin-bottom: 58px;

    > div {
        margin: 0;
    }

    .alignDate {
        margin-top: 0 !important;
    }

    ${styleHelpers.mobile`
        width: 100%;

        > div {
            margin-bottom: 0;
        }
    `}

    .rw-list-option {
        ${styleHelpers.mobile`
            width: 50%;
        `}
        .rw-select-list-label {
            background-color: ${colors.COOL_GREY};
            border: 1px solid ${colors.BLACK};
            padding: 16px 41px;
            line-height: 1;
            box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.2);
            margin: 0;
            cursor: pointer;

            ${styleHelpers.mobile`
                justify-content: center;
            `}

            .rw-select-list-input {
                display: none;
            }
        }

        &[aria-checked="true"] {
            .rw-select-list-label {
                background-color: ${colors.WHITE};
                box-shadow: none;
            }
        }
    }
`;

export const FileUploadLabel = styled.label`
    font-style: normal;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 2.2rem;
    color: ${colors.DARK_GREY};
    margin-bottom: 0;
    margin-left: 8px;
    margin-right: 8px;
`;

export const FileUploadContainer = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
    padding: 18px 8px;
    order: 99;

    &.with-dot {
        margin-bottom: 57px;
        padding: 0;

        &:after {
            content: '';
            background-image: linear-gradient(to right, ${colors.DARK_GREY} 33%, rgba(255, 255, 255, 0) 0%);
            background-position: bottom;
            background-size: 6px 2px;
            background-repeat: repeat-x;
            height: 2px;
            flex: 1 1 auto;
            width: auto;
            max-width: none;
        }
    }

    &.with-background {
        background-color: ${colors.WHITE};
        border-bottom: 1px solid ${colors.COOL_GREY};

        p {
            margin: 0;
        }
    }
`;

export const FileUpload = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;

    .hidden-button {
        display: none;
    }
`;

export const ItemContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export const LineButton = styled.button`
    -webkit-appearance: none;
    background: none;
    border: none;
    display: inline-flex;
    align-items: center;
    font-size: 1.6rem;
    line-height: 2rem;
    font-weight: 500;
    cursor: pointer;
    color: ${colors.BLACK};
    text-decoration: none;
    padding: 8px 17px;
`;

export const Icon = styled.img`
    margin-right: 10px;

    &.right {
        margin-right: 0;
        margin-left: 10px;
    }
`;
